import styled from 'styled-components';

import { iconFill, iconStroke } from '../../styles/mixin';
import { Icon } from '../Icon';

export const Label = styled.label<{ disabled?: boolean }>`
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    transition: all ${({ theme }) => theme.transitions.hover};
    background-color: white;
    border: 2px solid ${({ theme }) => theme.colors.mediumShadow};
    padding: 7px;
    border-radius: 4px;
    display: inline-block;
    position: relative;
    width: 1.25rem;
    height: 1.25rem;

    &:hover {
        border: 2px solid rgba(0, 0, 0, 0.2);
    }

    &:active {
        border: 2px solid rgba(0, 0, 0, 0.3);
    }
`;

export const Input = styled.input<{ indetermined?: boolean }>`
    position: absolute;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);

    &:focus + ${Label} {
        outline: -webkit-focus-ring-color auto 1px;
    }

    &${({ indetermined: ind }) => (ind ? '' : ':checked')} + ${Label} {
        background-color: ${({ theme }) => theme.colors.checkbox};
        border-color: ${({ theme }) => theme.colors.checkbox};

        &:hover {
            background-color: ${({ theme }) => theme.colors.checkbox}E6;
            border-color: ${({ theme }) => theme.colors.checkbox}E6;
        }

        &:active {
            background-color: ${({ theme }) => theme.colors.checkbox}CC;
            border-color: ${({ theme }) => theme.colors.checkbox}CC;
        }
    }
`;

export const StyledIcon = styled(Icon)<{ stroke?: boolean }>`
    width: 0.75rem;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    pointer-events: none;
    ${({ stroke }) => (stroke ? iconStroke('white') : iconFill('white'))};
`;
